import { useLoaderData } from 'react-router';
import type { Route } from './+types/privacy-policy';
import { LegalPage } from '~/pages/LegalPage';

export const loader = async ({ request }: Route.LoaderArgs) => {
  const response = await fetch(new URL('./privacy-policy.md', request.url));

  const markdown = await response.text();

  return { markdown };
};

export default function ViewTermsOfService() {
  const { markdown } = useLoaderData<{ markdown: string }>();

  return <LegalPage markdown={markdown} />;
}
